import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CustomerLayout } from '../../components/layouts/CustomerLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Car, Shield, Heart, Flame, UserCheck, Briefcase, ArrowRight } from 'lucide-react';
const insuranceConfig = {
  'third-party': {
    title: 'خرید بیمه شخص ثالث',
    icon: Car,
    color: 'text-blue-600',
    bg: 'bg-blue-100'
  },
  body: {
    title: 'خرید بیمه بدنه',
    icon: Shield,
    color: 'text-indigo-600',
    bg: 'bg-indigo-100'
  },
  health: {
    title: 'خرید بیمه درمان تکمیلی',
    icon: Heart,
    color: 'text-red-600',
    bg: 'bg-red-100'
  },
  fire: {
    title: 'خرید بیمه آتش‌سوزی',
    icon: Flame,
    color: 'text-orange-600',
    bg: 'bg-orange-100'
  },
  life: {
    title: 'خرید بیمه عمر',
    icon: UserCheck,
    color: 'text-green-600',
    bg: 'bg-green-100'
  },
  liability: {
    title: 'خرید بیمه مسئولیت',
    icon: Briefcase,
    color: 'text-purple-600',
    bg: 'bg-purple-100'
  }
};
export function InsuranceBuyPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'third-party';
  const config = insuranceConfig[type as keyof typeof insuranceConfig] || insuranceConfig['third-party'];
  const Icon = config.icon;
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      navigate('/insurance/compare');
    }, 1000);
  };
  const renderFormFields = () => {
    switch (type) {
      case 'body':
        return <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-439">
              <Select label="برند خودرو" options={[{
              value: 'peugeot',
              label: 'پژو'
            }, {
              value: 'pride',
              label: 'پراید'
            }]} required data-id="element-440" />
              <Select label="مدل خودرو" options={[{
              value: '206',
              label: '۲۰۶'
            }, {
              value: '207',
              label: '۲۰۷'
            }]} required data-id="element-441" />
              <Select label="سال ساخت" options={[{
              value: '1403',
              label: '۱۴۰۳'
            }, {
              value: '1402',
              label: '۱۴۰۲'
            }]} required data-id="element-442" />
              <Input label="ارزش روز خودرو (ریال)" type="number" placeholder="مثلا: ۵,۰۰۰,۰۰۰,۰۰۰" required data-id="element-443" />
            </div>
            <div className="space-y-4 mt-6" data-id="element-444">
              <h3 className="font-medium text-gray-900" data-id="element-445">پوشش‌های اضافی</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-446">
                <label className="flex items-center gap-2 border p-3 rounded-lg cursor-pointer hover:bg-gray-50" data-id="element-447">
                  <input type="checkbox" className="w-4 h-4 text-primary" data-id="element-448" />
                  <span className="text-sm" data-id="element-449">سرقت در جای قطعات</span>
                </label>
                <label className="flex items-center gap-2 border p-3 rounded-lg cursor-pointer hover:bg-gray-50" data-id="element-450">
                  <input type="checkbox" className="w-4 h-4 text-primary" data-id="element-451" />
                  <span className="text-sm" data-id="element-452">شکست شیشه</span>
                </label>
                <label className="flex items-center gap-2 border p-3 rounded-lg cursor-pointer hover:bg-gray-50" data-id="element-453">
                  <input type="checkbox" className="w-4 h-4 text-primary" data-id="element-454" />
                  <span className="text-sm" data-id="element-455">بلایای طبیعی</span>
                </label>
                <label className="flex items-center gap-2 border p-3 rounded-lg cursor-pointer hover:bg-gray-50" data-id="element-456">
                  <input type="checkbox" className="w-4 h-4 text-primary" data-id="element-457" />
                  <span className="text-sm" data-id="element-458">حذف فرانشیز</span>
                </label>
              </div>
            </div>
          </>;
      case 'health':
        return <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-459">
            <Select label="بیمه‌گر پایه" options={[{
            value: 'tamin',
            label: 'تامین اجتماعی'
          }, {
            value: 'salamat',
            label: 'سلامت'
          }, {
            value: 'none',
            label: 'فاقد بیمه پایه'
          }]} required data-id="element-460" />
            <Select label="تعداد اعضای خانواده" options={[{
            value: '1',
            label: '۱ نفر'
          }, {
            value: '2',
            label: '۲ نفر'
          }, {
            value: '3',
            label: '۳ نفر'
          }, {
            value: '4',
            label: '۴ نفر و بیشتر'
          }]} required data-id="element-461" />
            <Input label="سن بیمه‌شده اصلی" type="number" required data-id="element-462" />
            <Select label="طرح درخواستی" options={[{
            value: 'basic',
            label: 'طرح پایه'
          }, {
            value: 'silver',
            label: 'طرح نقره‌ای'
          }, {
            value: 'gold',
            label: 'طرح طلایی'
          }]} required data-id="element-463" />
          </div>;
      case 'fire':
        return <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-464">
            <Select label="نوع ملک" options={[{
            value: 'residential',
            label: 'مسکونی'
          }, {
            value: 'commercial',
            label: 'اداری/تجاری'
          }, {
            value: 'industrial',
            label: 'صنعتی'
          }]} required data-id="element-465" />
            <Select label="نوع سازه" options={[{
            value: 'concrete',
            label: 'بتنی'
          }, {
            value: 'metal',
            label: 'فلزی'
          }, {
            value: 'brick',
            label: 'آجری'
          }]} required data-id="element-466" />
            <Input label="متراژ بنا (متر مربع)" type="number" required data-id="element-467" />
            <Input label="ارزش لوازم منزل (ریال)" type="number" required data-id="element-468" />
            <Input label="ارزش بنا (ریال)" type="number" required data-id="element-469" />
            <Input label="کد پستی" type="number" maxLength={10} required data-id="element-470" />
          </div>;
      case 'life':
        return <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-471">
            <Input label="تاریخ تولد" placeholder="1370/01/01" required data-id="element-472" />
            <Select label="مدت قرارداد" options={[{
            value: '10',
            label: '۱۰ سال'
          }, {
            value: '20',
            label: '۲۰ سال'
          }, {
            value: '30',
            label: '۳۰ سال'
          }]} required data-id="element-473" />
            <Select label="نحوه پرداخت" options={[{
            value: 'monthly',
            label: 'ماهانه'
          }, {
            value: 'yearly',
            label: 'سالانه'
          }, {
            value: 'once',
            label: 'یکجا'
          }]} required data-id="element-474" />
            <Input label="توان پرداخت ماهانه (ریال)" type="number" placeholder="مثلا: ۵,۰۰۰,۰۰۰" required data-id="element-475" />
            <Select label="درصد افزایش سالانه حق بیمه" options={[{
            value: '0',
            label: '۰٪'
          }, {
            value: '10',
            label: '۱۰٪'
          }, {
            value: '15',
            label: '۱۵٪'
          }, {
            value: '20',
            label: '۲۰٪'
          }]} required data-id="element-476" />
            <Select label="پوشش فوت" options={[{
            value: 'normal',
            label: 'فوت به هر علت'
          }, {
            value: 'accident',
            label: 'فوت بر اثر حادثه'
          }]} required data-id="element-477" />
          </div>;
      case 'liability':
        return <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-478">
            <Select label="نوع فعالیت" options={[{
            value: 'construction',
            label: 'ساختمانی'
          }, {
            value: 'medical',
            label: 'پزشکی و پیراپزشکی'
          }, {
            value: 'industrial',
            label: 'مدیران صنعتی'
          }, {
            value: 'elevator',
            label: 'نصب و نگهداری آسانسور'
          }]} required data-id="element-479" />
            <Input label="تعداد کارکنان/واحدها" type="number" required data-id="element-480" />
            <Select label="سقف تعهد پزشکی (ریال)" options={[{
            value: '100m',
            label: '۱۰۰ میلیون'
          }, {
            value: '200m',
            label: '۲۰۰ میلیون'
          }, {
            value: '500m',
            label: '۵۰۰ میلیون'
          }]} required data-id="element-481" />
            <Select label="سقف تعهد فوت و نقص عضو" options={[{
            value: 'die',
            label: 'دیه کامل در ماه عادی'
          }, {
            value: 'die_haram',
            label: 'دیه کامل در ماه حرام'
          }]} required data-id="element-482" />
          </div>;
      case 'third-party':
      default:
        return <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-483">
              <Select label="نوع خودرو" options={[{
              value: 'passenger',
              label: 'سواری'
            }, {
              value: 'taxi',
              label: 'تاکسی'
            }, {
              value: 'truck',
              label: 'بارکش'
            }]} required data-id="element-484" />
              <Select label="برند خودرو" options={[{
              value: 'peugeot',
              label: 'پژو'
            }, {
              value: 'pride',
              label: 'پراید'
            }, {
              value: 'samand',
              label: 'سمند'
            }, {
              value: 'dena',
              label: 'دنا'
            }]} required data-id="element-485" />
              <Select label="مدل خودرو" options={[{
              value: '206',
              label: '۲۰۶'
            }, {
              value: '207',
              label: '۲۰۷'
            }, {
              value: 'pars',
              label: 'پارس'
            }, {
              value: '405',
              label: '۴۰۵'
            }]} required data-id="element-486" />
              <Select label="سال ساخت" options={[{
              value: '1403',
              label: '۱۴۰۳'
            }, {
              value: '1402',
              label: '۱۴۰۲'
            }, {
              value: '1401',
              label: '۱۴۰۱'
            }, {
              value: '1400',
              label: '۱۴۰۰'
            }, {
              value: '1399',
              label: '۱۳۹۹'
            }]} required data-id="element-487" />
            </div>
            <div className="space-y-4 mt-6" data-id="element-488">
              <h3 className="font-medium text-gray-900" data-id="element-489">سوابق بیمه قبلی</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-490">
                <Select label="شرکت بیمه قبلی" options={[{
                value: 'iran',
                label: 'بیمه ایران'
              }, {
                value: 'asia',
                label: 'بیمه آسیا'
              }, {
                value: 'dana',
                label: 'بیمه دانا'
              }, {
                value: 'pasargad',
                label: 'بیمه پاسارگاد'
              }]} data-id="element-491" />
                <Select label="تاریخ انقضای بیمه فعلی" options={[{
                value: 'valid',
                label: 'هنوز اعتبار دارد'
              }, {
                value: 'expired',
                label: 'منقضی شده است'
              }]} data-id="element-492" />
              </div>
            </div>
            <div className="space-y-4 mt-6" data-id="element-493">
              <h3 className="font-medium text-gray-900" data-id="element-494">
                درصد تخفیف عدم خسارت
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-495">
                <Select label="تخفیف ثالث" options={[{
                value: '0',
                label: 'صفر درصد'
              }, {
                value: '5',
                label: '۵ درصد'
              }, {
                value: '10',
                label: '۱۰ درصد'
              }, {
                value: '15',
                label: '۱۵ درصد'
              }, {
                value: '70',
                label: '۷۰ درصد'
              }]} data-id="element-496" />
                <Select label="تخفیف حوادث راننده" options={[{
                value: '0',
                label: 'صفر درصد'
              }, {
                value: '5',
                label: '۵ درصد'
              }, {
                value: '10',
                label: '۱۰ درصد'
              }]} data-id="element-497" />
              </div>
            </div>
          </>;
    }
  };
  return <CustomerLayout data-id="element-498">
      <div className="max-w-3xl mx-auto space-y-6" data-id="element-499">
        <div className="flex items-center gap-2 text-gray-500 mb-4 cursor-pointer hover:text-gray-900" onClick={() => navigate('/insurance/select')} data-id="element-500">
          <ArrowRight className="h-4 w-4" data-id="element-501" />
          <span data-id="element-502">بازگشت به انتخاب نوع بیمه</span>
        </div>

        <div className="text-center mb-8" data-id="element-503">
          <div className={`inline-flex items-center justify-center p-4 rounded-full mb-4 ${config.bg} ${config.color}`} data-id="element-504">
            <Icon className="h-8 w-8" data-id="element-505" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-506">{config.title}</h1>
          <p className="text-gray-500 mt-2" data-id="element-507">
            برای استعلام قیمت، اطلاعات زیر را تکمیل کنید
          </p>
        </div>

        <Card data-id="element-508">
          <CardHeader data-id="element-509">
            <CardTitle className="text-lg" data-id="element-510">اطلاعات مورد نیاز</CardTitle>
          </CardHeader>
          <CardContent data-id="element-511">
            <form onSubmit={handleSubmit} data-id="element-512">
              {renderFormFields()}

              <Button type="submit" className="w-full h-12 text-lg mt-8" isLoading={isLoading} data-id="element-513">
                استعلام قیمت و مقایسه
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </CustomerLayout>;
}